import React from 'react';
import { Box, Clock, Text } from 'grommet';
import { useSelector } from 'react-redux';
import { getEndTimestamp } from 'src/reducers/workSessions/workSessionsSelectors';
import { getClockTime } from 'src/utils/date.utils';

function EstimatedEndTime(): JSX.Element {
  const endTimestamp = useSelector(getEndTimestamp);

  return (
    <Box direction='row'>
      <Text>Estimated end time:&nbsp;</Text>
      <Clock type='digital' time={getClockTime(new Date(endTimestamp))} run={false} />
    </Box>
  );
}

export default EstimatedEndTime;
